import {CatalogConfig} from '../types'

// Moderation catalogs — decline reasons shown when a moderator rejects a submission.
// Backed by community.DeclineReason and expertise.ExpertiseDeclineReason (kept separate on
// purpose: rejecting a community post and rejecting a paid service surface different reasons,
// and sharing the table would show irrelevant options in each modal).
// Both models use `title` (not `name`) as the primary field.

export const communityDeclineReasonsConfig: CatalogConfig = {
  slug: 'community-decline-reasons',
  endpoint: '/catalog/admin/community-decline-reasons/',
  titleId: 'CATALOG.COMMUNITY_DECLINE_REASONS.TITLE',
  singularId: 'CATALOG.COMMUNITY_DECLINE_REASONS.SINGULAR',
  primaryField: 'title',
  writable: true,
  reorderable: true,
  softDelete: {field: 'isActive', activeValue: true},
  serverSide: {
    searchParam: 'search',
    orderingParam: 'ordering',
    statusParam: 'isActive',
    sortableFields: ['order', 'title'],
    defaultOrdering: 'order',
  },
  fields: [
    {name: 'order', labelId: 'CATALOG.FIELD.ORDER', type: 'text', showInTable: true},
    {
      name: 'title',
      labelId: 'CATALOG.FIELD.TITLE',
      type: 'text',
      showInTable: true,
      searchable: true,
      required: true,
      maxLength: 150,
    },
  ],
}

export const expertiseDeclineReasonsConfig: CatalogConfig = {
  slug: 'expertise-decline-reasons',
  endpoint: '/catalog/admin/expertise-decline-reasons/',
  titleId: 'CATALOG.EXPERTISE_DECLINE_REASONS.TITLE',
  singularId: 'CATALOG.EXPERTISE_DECLINE_REASONS.SINGULAR',
  primaryField: 'title',
  writable: true,
  reorderable: true,
  softDelete: {field: 'isActive', activeValue: true},
  serverSide: {
    searchParam: 'search',
    orderingParam: 'ordering',
    statusParam: 'isActive',
    sortableFields: ['order', 'title'],
    defaultOrdering: 'order',
  },
  fields: [
    {name: 'order', labelId: 'CATALOG.FIELD.ORDER', type: 'text', showInTable: true},
    {
      name: 'title',
      labelId: 'CATALOG.FIELD.TITLE',
      type: 'text',
      showInTable: true,
      searchable: true,
      required: true,
      maxLength: 150,
    },
  ],
}

export const moderationCatalogConfigs: CatalogConfig[] = [
  communityDeclineReasonsConfig,
  expertiseDeclineReasonsConfig,
]
